import React from 'react';
import { motion } from 'framer-motion';
export function LegalSection() {
  return <section className="py-0 px-5 md:px-[5%] bg-white" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-[#e9ecef] py-[60px] px-5 md:px-[5%] text-center rounded-[15px] max-w-6xl mx-auto" data-id="element-58">
        <h3 className="text-verde-oscuro text-2xl md:text-3xl font-serif mb-4" data-id="element-59">
          Compromiso y Transparencia Legal
        </h3>
        <p className="text-lg font-sans text-texto mb-8 max-w-2xl mx-auto" data-id="element-60">
          Operamos bajo las más estrictas normas provinciales para tu total
          tranquilidad.
        </p>

        <div className="flex flex-wrap gap-5 justify-center mt-[30px]" data-id="element-61">
          <a href="https://apps2.entrerios.gov.ar/consulta/normas-api/obtenerImagen?id=pmbkZMPvaz" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-verde-oscuro text-verde-oscuro py-[15px] px-[25px] no-underline rounded-md font-bold font-sans transition-all hover:bg-verde-oscuro hover:text-white focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-verde-oscuro/30" data-id="element-62">
            VER LEY 10.932
          </a>
          <a href="https://e-legis-ar.msal.gov.ar/legisalud/migration/pdf/erley10932.pdf" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-verde-oscuro text-verde-oscuro py-[15px] px-[25px] no-underline rounded-md font-bold font-sans transition-all hover:bg-verde-oscuro hover:text-white focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-verde-oscuro/30" data-id="element-63">
            VER DECRETO 1116
          </a>
        </div>
      </motion.div>
    </section>;
}